import styles from "./SettingsLayout.module.css";
import NavigationSidebar from "../NavigationSidebar/NavigationSidebar";
import { Outlet } from "react-router-dom";

const SettingsLayout = () => {
  return (
    <div className={styles.layout}>
      <NavigationSidebar />
      <div className={styles.settingsPage}>
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsLayout;
